import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { IExpandCollapse } from '../popular-bets.models';

@Injectable()
export class PopularBetsExpandCollapseService {
    private triggerExpandCollapse$ = new Subject<IExpandCollapse>();

    setExpandCollapse(isExpanded: boolean, noOfLegs: number): void {
        this.triggerExpandCollapse$.next({ isExpanded, noOfLegs });
    }

    getExpandCollapse(): Subject<IExpandCollapse> {
        return this.triggerExpandCollapse$;
    }
}
